import React from 'react';
import { Formik } from 'formik';

import { StepProps, StepsId } from '../../types';
import ScreeningForm from './components/ScreeningForm';
import { useMultiTierCheckout } from '../../context';

const RequestScreeningStep = ({ goToStep }: StepProps) => {
  const {
    data: { requestScreening },
    onSuccess
  } = useMultiTierCheckout();

  const goToTicketSelection = () => {
    goToStep(StepsId.TicketsSelectionStep);
  };

  const handleOnSubmit = (values) => {
    requestScreening.submitRequest(values).then(() => {
      onSuccess();
      goToStep(StepsId.SuccessRequestApprovalStep);
    });
  };

  return (
    <Formik initialValues={{}} onSubmit={handleOnSubmit}>
      {(formProps) => (
        <ScreeningForm
          data={requestScreening.questions}
          goToTicketSelection={goToTicketSelection}
          error={requestScreening.error}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...formProps}
        />
      )}
    </Formik>
  );
};

export default RequestScreeningStep;
